import { render, staticRenderFns } from "./DoctorVisitsStatistics.vue?vue&type=template&id=e100477e&scoped=true&"
import script from "./DoctorVisitsStatistics.vue?vue&type=script&lang=js&"
export * from "./DoctorVisitsStatistics.vue?vue&type=script&lang=js&"
import style1 from "./DoctorVisitsStatistics.vue?vue&type=style&index=1&id=e100477e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e100477e",
  null
  
)

export default component.exports